import {each, isPlainObject} from 'helpers';
import {isGoogleEventId} from 'store/google-calendar';

//find google event id recursively
//if found - create new activity to replace the imported one
export function activities({ dispatch }) {
  return next => action => {
    if (!ignore(action)) {
      let googleEventId;

      (function injectGoogleId(object) {
        each(object, (value, property) => {
          if (isPlainObject(value)) {
            injectGoogleId(value);
          } else if (isGoogleEventId(value))   {
            googleEventId = value;
            object[property] = action.generateId(googleEventId);
          }
        });
      })(action);

      if (googleEventId) {
        dispatch({
          type: 'ACTIVITIES_STORE_GOOGLE_EVENT',
          googleEventId,
          id: action.generateId(googleEventId),
        });
      }
    }
    return next(action);
  }
}

function ignore({ type }) {
  return /^(APP_|SERVER_|GOOGLE_CALENDAR_|ACTIVITIES_STORE_GOOGLE_EVENT|ACTIVITIES_DELETE|ACTIVITIES_DUPLICATE)/.test(type);
}
